module.exports = __webpack_public_path__ + "static/media/asahi-mizuno-lesb.f6dc8789.jpg";